import {dateToString} from "../utils/dateToString";
import {stringToDate} from "../utils/stringToDate";
export function printSurveyParticipantsAndDate(survey, container, answers) {
    var className = "participants_date_container";
    if (container.find("." + className).length === 0) {
        var surveyDate = stringToDate(survey.validity_to),
            now = new Date();
        var textParticipants = "Teilnehmer bisher: " + answers,
            textDate = "";
        if (surveyDate >= now) {
            textDate = "Umfrage läuft noch bis " + dateToString(surveyDate);
        } else {
            textParticipants = "Teilnehmer: " + answers;
        }
        $('<div class="' + className + '">' + textParticipants + "<br />" + textDate + '</div>').insertBefore(container.find('.answers'));
    }
}